<div class="grid grid-cols-3 gap-10">
  <div class="row-span-2">
    <app-card>
      <h3 class="font-bold">{{ 'page.project-detail-info.details.title' | translate }}</h3>

      <div class="mt-2 -mx-6">
        <app-detail-entry-field label="{{ 'page.project-detail-info.details.list.name' | translate }}">{{ (project$ | async)?.name }}</app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.project-detail-info.details.list.description' | translate }}">{{ (project$ | async)?.description }}</app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.project-detail-info.details.list.customer' | translate }}">{{ (project$ | async)?.customer }}</app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.project-detail-info.details.list.status' | translate }}">{{ 'project.status.' + (project$ | async)?.status | translate }}</app-detail-entry-field>
        <app-detail-entry-field *ngIf="(project$ | async)?.externalId " label="{{ 'page.project-detail-info.details.list.external-id' | translate }}">{{ (project$ | async)?.externalId }}</app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.project-detail-info.details.list.created-at' | translate }}">{{ (project$ | async)?.createdAt | date:'dd-MM-yyyy HH:mm' }}</app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.project-detail-info.details.list.created-by' | translate }}">{{ (project$ | async)?.createdBy.email }}</app-detail-entry-field>
      </div>
    </app-card>
  </div>

  <ng-container *ngIf="project$ | async as project">
    <div class="col-span-2">
      <app-card>
        <h3 class="font-bold">{{ 'page.project-detail-info.project-admins.title' | translate }}</h3>
        <div class="mb-10 w-full max-w-xl flex flex-col gap-4 items-start justify-start" appProjectAdminAccess [project]="project">
          <p class="text-gray-500 text-sm">
            {{ 'page.project-detail-info.project-admins.instruction' | translate }}
          </p>

          <p *ngIf="invitingAdminSuccess" class="text-green-500 text-sm">{{ 'page.project-detail-info.project-users.invited' | translate }}</p>
          <p *ngIf="invitingAdminError" class="text-red-500 text-sm">{{ 'page.project-detail-info.project-users.invite-error' | translate }}</p>

          <app-input placeholder="{{ 'page.project-detail-info.project-admins.email-placeholder' | translate }}" [formControl]="invitingAdminControl"></app-input>
          <app-button text="{{ 'page.project-detail-info.project-admins.invite-user' | translate }}" (click)="inviteAdmin()" [loading]="invitingAdmin"></app-button>
        </div>

        <app-table [columns]="columns" [data]="adminAssignments$ | async" [hasDelete]="(isProjectAdmin$ | async) ?? false" (delete)="deleteAssignment($event)"></app-table>
      </app-card>
    </div>
    <div class="col-span-2">
      <app-card>
        <h3 class="font-bold">{{ 'page.project-detail-info.project-users.title' | translate }}</h3>
        <div class="mb-10 w-full max-w-xl flex flex-col gap-4 items-start justify-start" appProjectAdminAccess [project]="project">
          <p class="text-gray-500 text-sm">
            {{ 'page.project-detail-info.project-users.instruction' | translate }}
          </p>

          <p *ngIf="invitingUserSuccess" class="text-green-500 text-sm">{{ 'page.project-detail-info.project-users.invited' | translate }}</p>
          <p *ngIf="invitingUserError" class="text-red-500 text-sm">{{ 'page.project-detail-info.project-users.invite-error' | translate }}</p>

          <app-input placeholder="{{ 'page.project-detail-info.project-users.email-placeholder' | translate }}" [formControl]="invitingUserControl"></app-input>

          <app-button text="{{ 'page.project-detail-info.project-users.invite-user' | translate }}" (click)="inviteUser()" [loading]="invitingUser"></app-button>
        </div>

        <app-table [columns]="columns" [data]="userAssignments$ | async" [hasDelete]="(isProjectAdmin$ | async) ?? false" (delete)="deleteAssignment($event)"></app-table>
      </app-card>
    </div>
  </ng-container>
</div>
